import { useEffect } from 'react';

/**
 * Custom hook to debounce an effect.
 * @param {Function} effect - The effect function to debounce.
 * @param {Array} deps - The dependency array for the effect.
 * @param {number} delay - The debounce delay in milliseconds.
 */
export const useDebounceEffect = (effect, delay,deps = []) => {
  useEffect(() => {
    const handler = setTimeout(() => {
      effect();
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [...deps, delay]);
};